import { Component, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogService } from 'src/app/services/dialog.service';
import { BuscCarpetaService } from 'src/app/services/perfilamiento/busc-carpeta.service';
import { ConvenioService } from '../../services/catalogos/convenios.service';
import { Pagaduriaservice } from '../../services/catalogos/pagadurias.service';
import { NgbCalendar, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-busqueda-carpetas',
  templateUrl: './busqueda-carpetas.component.html',
  styleUrls: ['./busqueda-carpetas.component.scss'],
})
export class BusquedaCarpetasComponent {

  @ViewChild('fechaTemplate', { static: true }) fechaTemplate!: TemplateRef<any>;
  @ViewChild('cedulaTemplate', { static: true }) cedulaTemplate!: TemplateRef<any>;
  @ViewChild('carpetaTemplate', { static: true }) carpetaTemplate!: TemplateRef<any>;
  @ViewChild('apellidoTemplate', { static: true }) apellidoTemplate!: TemplateRef<any>;
  @ViewChild('pagaduriaTemplate', { static: true }) pagaduriaTemplate!: TemplateRef<any>;
  // @ViewChild('nombreTemplate', { static: true }) nombreTemplate!: TemplateRef<any>;

  myTabs: { title: string; content: TemplateRef<any> }[] = [];
  searching: boolean = false;
  entradabusqueda: string = '';
  fechaInicial: any = '';
  fechaFinal: any = '';
  convenio: string = '';
  pagaduria: string = '';
  convenios: any;
  pagaduarias: any;
  today: NgbDateStruct;

  public filteredConvenio: any;
  public filteredPagaduria: any;

  constructor(
    private busService: BuscCarpetaService,
    private router: Router,
    private dialogService: DialogService,
    private pagaduriaService: Pagaduriaservice,
    private convenioService: ConvenioService,
    public dialog: MatDialog,
    private calendar: NgbCalendar

  ) { 
    this.today = this.calendar.getToday();
  }

  ngOnInit() {
    this.getConvenios();
    this.myTabs = [
      { title: 'Cédula', content: this.cedulaTemplate },
      { title: 'Fecha de creación', content: this.fechaTemplate },
      { title: 'Pagaduría', content: this.pagaduriaTemplate },
      { title: 'Apellido', content: this.apellidoTemplate },
      { title: 'Número de carpeta', content: this.carpetaTemplate },
      // { title: 'Nombre', content: this.nombreTemplate }
    ];
  }

  async buscar(dataBusqueda) {
    this.searching = true;

    switch (dataBusqueda) {
      case 'cedula':
        let numeroDocumento = parseInt(this.entradabusqueda);
        this.exeBusqueda({ numeroDocumento });
        break;
      case 'pagaduria':
        let codigoPagaduria = parseInt(this.pagaduria);
        this.exeBusqueda({ codigoPagaduria });
        break;
      case 'nombre':
        let nombreCliente = this.entradabusqueda.toString();
        this.exeBusqueda({ nombreCliente });
        break;
      case 'apellido':
        let primerApellido = this.entradabusqueda;
        this.exeBusqueda({ primerApellido });
        break;
      case 'numsolicitud':
        let numeroSolicitud = parseInt(this.entradabusqueda);
        this.exeBusqueda({ numeroSolicitud });
        break;
      case 'numcarpeta':
        let numeroCarpeta = parseInt(this.entradabusqueda);
        this.exeBusqueda({ numeroCarpeta });
        break;
      case 'fecha':
        const {
          year: initYear,
          month: initMonth,
          day: initDay,
        } = this.fechaInicial;
        const {
          year: lastYear,
          month: lastMonth,
          day: lastDay,
        } = this.fechaFinal;

        const initMonthCom = initMonth < 10 ? `0${initMonth}` : `${initMonth}`;
        const initDayCom = initDay < 10 ? `0${initDay}` : `${initDay}`;
        const initDate = `${initYear}-${initMonthCom}-${initDayCom}`;
        const lastMonthCom = lastMonth < 10 ? `0${lastMonth}` : `${lastMonth}`;
        const lastDayCom = lastDay < 10 ? `0${lastDay}` : `${lastDay}`;
        const lastDate = `${lastYear}-${lastMonthCom}-${lastDayCom}`;

        this.exeBusqueda({ fechaInicial: initDate, fechaFinal: lastDate });
        break;
    }
  }

  private exeBusqueda(value: any): void {
    this.busService.getResultadosBusqueda(value).subscribe(
      async (res) => {
        this.searching = false;
        if (res.count == 0) {
          this.dialogService.openDialog(
            'Advertencia',
            'No se encontraron resultados',
            false
          );
          return;
        }
        this.router.navigate(['/resultado-carpetas'], { state: { respuesta: JSON.stringify(res)} });
      },
      (err) => {
        this.dialogService.openDialog('Advertencia', err.error.mensaje, false);
        this.searching = false;
      }
    );
  }

  getConvenios() {
    this.convenioService.getConvenios().subscribe((convenios) => {
      this.convenios = convenios.rows;
      this.filteredConvenio = this.convenios.slice();
    });
  }

  getPagadurias(convenio: any) {
    console.log(convenio);
    this.pagaduriaService.getPagadurias(convenio).subscribe((pagaduria) => {
      this.pagaduarias = pagaduria.rows;
      this.filteredPagaduria = this.pagaduarias.slice();
    });
  }
}
